import Container from "../calculatorcontainer";

const Component = () => {

    return (
        <>
            <Container type={"affordability"} header={"How Much Can I Afford?"}>
                <li className="calcPgStructure">
                    <div className="comingSoonText">Coming soon</div>
                </li>
            </Container>
        </>
    )
}

export default Component;